__turbopack_context__.v({
  "arrow": "paginationArrows-module__-_3meW__arrow",
  "root": "paginationArrows-module__-_3meW__root",
});
